import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';
import { TestViewViewModel } from 'src/app/shared/models/test.model';
import { TestService } from 'src/app/shared/test.service';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatLabel } from '@angular/material/form-field';

import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-config-test-view-card',
    templateUrl: './config-test-view-card.component.html',
    styleUrls: ['./config-test-view-card.component.css'],
    imports: [MatCard, MatCardHeader, MatCardAvatar, MatIcon, MatCardTitle, MatLabel, MatCardSubtitle, MatCardContent, MatCardActions, MatButton, RouterLink]
})
export class ConfigTestViewCardComponent implements OnInit {

  @Input() TestView: TestViewViewModel;
  @Output() onDelete:  EventEmitter<any> = new EventEmitter();

  constructor(private dialog: MatDialog, private testService: TestService) { }

  ngOnInit(): void {
  }


  deleteView(){
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: "Do you want to delete '" + this.TestView.Name + "'? "
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.testService.deleteTestView(this.TestView.TestViewId).subscribe(res=>{
          if(res){
            this.onDelete.emit({message: 'Deleted'});
          }
            
        });
      }
    });
  }

}
